import { Model } from '@/models/Model';

export interface CourseLine extends Model {
  name: string;
  category: CourseLineCategory;
  subcategory: CourseLineSubCategory;
  bannerImg?: File | string;
}

export enum CourseLineCategory {
  LANGUAGE = 'LANGUAGE',
  TECHNOLOGY = 'TECHNOLOGY',
  SCHOOL_REINFORCEMENT = 'SCHOOL_REINFORCEMENT',
}

export enum CourseLineSubCategory {
  ENGLISH = 'ENGLISH',
  SPANISH = 'SPANISH',
  CTRL_PLAY = 'CTRL_PLAY',
}
